import {
   Stack,
   ContentCard,
   Grid,
   Button,
   Select,
   WeeklyAvailability,
} from '@forwardflow/ui-v2'
import { ArrowLeftMdIcon, ChevronRightIcon } from '@forwardflow/icons'
import { motion } from 'framer-motion'
import { timeZones } from '@forwardflow/helpers/utils'
import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { IAvailabilityDay } from '@forwardflow/types/onboarding'
import { useState } from 'react'

export const LeadsAvailability = () => {
   const {
      getNextStep,
      getPreviousStep,
      setAppointmentTimeframe,
      setBusinessHours,
      onboardingData,
   } = useOnboardingStoreV2()
   const { businessHours, appointmentTimeframe } = onboardingData
   const [selectedDays, setSelectedDays] = useState<IAvailabilityDay[]>(
      businessHours?.days ?? []
   )
   const [isSameForAllDays, setIsSameForAllDays] = useState(
      businessHours?.isSameForAllDays ?? false
   )

   const handleTimeZoneChange = (value: string) => {
      setBusinessHours({
         ...businessHours,
         timezone: value,
      })
   }

   const handleWeeklyAvailabilityChange = () => {
      setBusinessHours({
         ...businessHours,
         days: selectedDays,
         isSameForAllDays: isSameForAllDays,
      })
   }

   const handleConfirmAndContinue = () => {
      if (!appointmentTimeframe?.timezone && businessHours?.timezone) {
         setAppointmentTimeframe({
            ...appointmentTimeframe,
            timezone: businessHours?.timezone,
         })
      }
      handleWeeklyAvailabilityChange()
      getNextStep()
   }

   return (
      <Stack gap={32}>
         <ContentCard
            className="space-y-2"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
         >
            <p className="text-white font-medium">
               When can Forward Flow reach out to your leads?
            </p>
            <p className="text-[#99A1AF] text-sm font-medium max-w-[600px]">
               Set the hours when your assistant is allowed to call or text your
               leads. You can choose one common schedule for multiple days or
               customize hours for each day. Forward Flow will only engage
               within these times.
            </p>
         </ContentCard>

         <ContentCard
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.6 }}
         >
            <Select
               value={businessHours?.timezone}
               data={timeZones}
               placeholder="Select Timezone"
               label="Select Timezone"
               onChange={(value) => handleTimeZoneChange(value as string)}
            />
         </ContentCard>
         <ContentCard
            className="!p-0"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.9 }}
         >
            <p className="text-white font-medium p-8 pb-0">
               Weekly Calling Hours
            </p>
            <WeeklyAvailability
               isSameForAllDays={isSameForAllDays}
               selectedDays={selectedDays}
               setSelectedDays={setSelectedDays}
               setIsSameForAllDays={setIsSameForAllDays}
            />
         </ContentCard>
         <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 1.2 }}
         >
            <Grid>
               <Grid.Col span={3}>
                  <Button
                     variant="secondary"
                     className="w-full"
                     onClick={() => getPreviousStep()}
                  >
                     <ArrowLeftMdIcon width={12} /> Back
                  </Button>
               </Grid.Col>
               <Grid.Col span={9}>
                  <Button
                     className="w-full"
                     onClick={() => handleConfirmAndContinue()}
                     disabled={
                        !businessHours?.timezone ||
                        !selectedDays?.some((d) => d.enabled)
                     }
                  >
                     Confirm and Continue <ChevronRightIcon width={18} />
                  </Button>
               </Grid.Col>
            </Grid>
         </motion.div>
      </Stack>
   )
}
